export default __webpack_public_path__ + "static/media/shocklance.10ba27d0.png";